import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import NewPlaylistForm from '../Common/Arrangement/PlaylistModal/NewPlaylistForm.jsx';


const PlaylistsCreateModal = () => {
  let [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return(
  <div className={'mb-3'}>
    <Button onClick={ handleShow } variant='link'>
      <i className='icon icon-plus'></i> { gettext('Создать плейлист') }
    </Button>

    <Modal show={ show } onHide={ handleClose } size='md'>
      <Modal.Header closeButton>
        <Modal.Title>
          { gettext('Создать плейлист') }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NewPlaylistForm/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ handleClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  </div>
  )
}

export default PlaylistsCreateModal;
